import ApiErrorClass from './ApiError.class';
import AppErrorClass from './AppError.class';

export const ApiError = ApiErrorClass;
export const AppError = AppErrorClass;
